import { render, staticRenderFns } from "./schoolProfile.vue?vue&type=template&id=621df67c&scoped=true"
import script from "./schoolProfile.vue?vue&type=script&lang=js"
export * from "./schoolProfile.vue?vue&type=script&lang=js"
import style0 from "./schoolProfile.vue?vue&type=style&index=0&id=621df67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621df67c",
  null
  
)

export default component.exports